export const environment = {
  production: false,
  appCode: 'app-134007',
  appName: 'finance-management',
  apiServerHost: 'https://dit.capvizon.com',
  cuiAppUrl: 'http://dit.cui.capvizon.com/',
  showDevTools: true,
};
